import { useMasterParams } from "@/api/master-param";
import { useState, useEffect } from "react";

interface UseValidationTimerProps {
  isValidating: boolean;
  updatedDate?: string;
}

export function useValidationTimer({
  isValidating,
  updatedDate,
}: UseValidationTimerProps) {
  const [isMoreThanThreshold, setIsMoreThanThreshold] = useState(false);
  const { data: cancelDurations } = useMasterParams({
    paramType: "ITV_CANCEL_NN_EVIDENCE",
    active: "true",
  });

  const cancelDurationInMinutes = Number(cancelDurations?.content?.[0]?.value);

  useEffect(() => {
    const checkIfMoreThanThreshold = () => {
      if (!isValidating || !updatedDate || !cancelDurationInMinutes) {
        setIsMoreThanThreshold(false);
        return;
      }

      const updateDate = new Date(updatedDate);
      const now = new Date();
      const differenceInMinutes =
        (now.getTime() - updateDate.getTime()) / 1000 / 60;
      setIsMoreThanThreshold(differenceInMinutes >= cancelDurationInMinutes);
    };

    // Check immediately
    checkIfMoreThanThreshold();

    // Then check every second for real-time updates
    const intervalId = setInterval(checkIfMoreThanThreshold, 1000);

    return () => clearInterval(intervalId);
  }, [isValidating, updatedDate, cancelDurationInMinutes]);

  return isMoreThanThreshold;
}
